<template>
  <div class="overflow-hidden">
    <div class="float-left overflow-hidden">
      <div>
        <a
          v-if="filesrc"
          :href="previewlink($ossUrl + filesrc)"
          target="__blank"
          >{{ filename }}</a
        >
      </div>
      <a-upload
        :before-upload="beforeUpload"
        :customRequest="api"
        :show-upload-list="false"
        :accept="accept"
        :disabled="disabled"
      >
        <a-button>
          <a-icon type="loading" v-if="loading" />
          <a-icon type="plus" v-else />
          上传
        </a-button>
      </a-upload>
    </div>
  </div>
</template>
<script>
import { previewlink } from '@/utils/tool';
export default {
  props: {
    accept: {
      default: 'image/*',
      type: String,
    },
    src: String,
    name: String,
    disabled: Boolean,
  },
  data() {
    return {
      filesrc: '',
      filename: '',
      loading: false,
    };
  },
  mounted() {
    this.filesrc = this.src;
    this.filename = this.name;
  },
  watch: {
    src(a) {
      this.filesrc = a;
    },
    name(a) {
      this.filename = a;
    },
  },
  methods: {
    previewlink,
    beforeUpload(file) {
      const isLt = file.size / 1024 / 1024 < 50;
      if (!isLt) {
        this.$message.error('上传文件需小于50MB!');
        return false;
      }
      return isLt;
    },
    async api(e) {
      let formData = new FormData();
      formData.append('file', e.file);
      formData.append('where', 'file');
      formData.append('style', '1');
      this.loading = true;
      let res = await this.$uploadfile('/api/v1/file_upload', formData);
      this.filesrc = res.pathname;
      this.filename = res.filename;
      this.$emit('upload', res);
      this.loading = false;
    },
  },
};
</script>
